/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { Company } from './Company';
import {
    CompanyFromJSON,
    CompanyFromJSONTyped,
    CompanyToJSON,
    CompanyToJSONTyped,
} from './Company';

/**
 * 
 * @export
 * @interface ListCompaniesBelongingToUserResponse
 */
export interface ListCompaniesBelongingToUserResponse {
    /**
     * 
     * @type {Array<Company>}
     * @memberof ListCompaniesBelongingToUserResponse
     */
    data: Array<Company>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListCompaniesBelongingToUserResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListCompaniesBelongingToUserResponse interface.
 */
export function instanceOfListCompaniesBelongingToUserResponse(value: object): value is ListCompaniesBelongingToUserResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListCompaniesBelongingToUserResponseFromJSON(json: any): ListCompaniesBelongingToUserResponse {
    return ListCompaniesBelongingToUserResponseFromJSONTyped(json, false);
}

export function ListCompaniesBelongingToUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListCompaniesBelongingToUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(CompanyFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListCompaniesBelongingToUserResponseToJSON(json: any): ListCompaniesBelongingToUserResponse {
      return ListCompaniesBelongingToUserResponseToJSONTyped(json, false);
  }

  export function ListCompaniesBelongingToUserResponseToJSONTyped(value?: ListCompaniesBelongingToUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(CompanyToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

